import { ArrowForwardRounded, Close } from '@mui/icons-material'
import { alpha, Box, Card, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material'
import { IApprovalAuditChanges } from '../../../../definitions/Approval'

interface P {
    open: boolean
    onClose: () => void
    differences: IApprovalAuditChanges[]
}
const extractValue = (val: any) => {
    if (val === '') return '""'
    if (val === undefined || val === null) return String(val)
    if (typeof val === 'object' || Array.isArray(val)) return <pre>{JSON.stringify(val, null, 2)}</pre>
    return String(val)
}
const formatPath = (path: string) => {
    return path
        .replace(/\[\d+\]/g, ' (item)') // settlementConfigs[0] -> settlementConfigs (item)
        .replace(/\./g, ' ➔ ') // hierarchy separator
        .replace(/([A-Z])/g, ' $1') // camelCase to space
        .trim()
}
const ContractChangesModal = ({ open, onClose, differences }: P) => {
    const renderModalContent = () => {
        return (
            <Card sx={{ padding: 2, overflowY: 'auto', flex: 1 }}>
                <DialogContent sx={{ pb: 2 }}>
                    <Box>
                        {differences.length > 0
                            ? differences.map((c, i) => {
                                return (
                                    <Stack key={i} spacing={1}>
                                        <Stack flexDirection='row' gap={0.5} alignItems='baseline'>
                                            <Typography variant='body2'>{c.type}</Typography>
                                            <Typography variant='body2' fontWeight={500}>{formatPath(c.path)}</Typography>
                                        </Stack>
                                        <Stack flexDirection='row' gap={0.5} alignItems='center'>
                                            {(c.type === 'update' || c.type === 'delete') && (
                                                <Stack
                                                    sx={{
                                                        padding: 'calc(var(--unit) * 0.5) var(--unit)',
                                                        borderRadius: 1,
                                                        border: '1px solid',
                                                        borderColor: theme => alpha(theme.palette.error.main, 0.5),
                                                        backgroundColor: theme => alpha(theme.palette.error.main, 0.3) }}>
                                                    <Typography variant='caption'>{extractValue(c.prevValue)}</Typography>
                                                </Stack>
                                            )}
                                            {c.type === 'update' && <ArrowForwardRounded fontSize='small' />}
                                            {(c.type === 'update' || c.type === 'create') && (
                                                <Stack
                                                    sx={{
                                                        padding: 'calc(var(--unit) * 0.5) var(--unit)',
                                                        borderRadius: 1, border: '1px solid',
                                                        borderColor: theme => alpha(theme.palette.success.main, 0.5),
                                                        backgroundColor: theme => alpha(theme.palette.success.main, 0.3) }}>
                                                    <Typography variant='caption'>{extractValue(c.newValue)}</Typography>
                                                </Stack>
                                            )}
                                        </Stack>
                                    </Stack>
                                )
                            })
                            : (
                                    <Stack alignItems='center'>
                                        <Typography>NO CHANGES MADE</Typography>
                                    </Stack>
                                )}
                    </Box>
                </DialogContent>
            </Card>
        )
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth='sm'
            fullWidth
            PaperProps={{ sx: { borderRadius: 2, minHeight: 450 } }}>
            <DialogTitle sx={{ pb: 1 }}>
                <Box display='flex' justifyContent='space-between' alignItems='center'>
                    <Typography>Changes</Typography>
                    <IconButton onClick={onClose} size='small'>
                        <Close />
                    </IconButton>
                </Box>
            </DialogTitle>
            {renderModalContent()}
        </Dialog>
    )
}

export default ContractChangesModal
